import React from 'react';
import TeamTableRow from './TeamTableRow';
import classNames from 'classnames';
import 'styles/admin/TeamsTable.styl';

export default class TeamsTable extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.onDragEnter = this.onDragEnter.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }
  onDragEnter(e) {
    if (e.dataTransfer.effectAllowed === 'move') {
      e.preventDefault();
      if (this.props.department !== this.props.departmentStagedToReceive) {
        this.props.onStageDepartmentToReceive(this.props.department);
      }
    }
  }
  onDragOver(e) {
    e.preventDefault();
  }
  onDrop(e) {
    if (e.dataTransfer.effectAllowed === 'move') {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      if (this.props.departmentStagedToRemoveFrom !== this.props.departmentStagedToReceive) {
        this.props.onCommitTeamMove();
      } else {
        this.props.onDiscardTeamMove();
      }
    }
  }
  render() {
    const {
      teams,
      teamStagedForMove,
      departmentStagedToReceive,
      departmentStagedToRemoveFrom,
      department,
      showTeamDialog,
    } = this.props;

    if (!teams && this.props.isLoading === undefined) {
      return null;
    }

    const classes = classNames('teams-table', 'generic-table', {
      'staged-to-receive':
        department === departmentStagedToReceive && department !== departmentStagedToRemoveFrom,
      'staged-to-remove-from': department === departmentStagedToRemoveFrom,
      'animated pulse': department === departmentStagedToReceive,
      highlight: !!teamStagedForMove,
    });
    return (
      <table
        className={classes}
        onDragEnter={this.onDragEnter}
        onDragOver={this.onDragOver}
        onDrop={this.onDrop}>
        <thead>
          <tr>
            <th className="reorder" />
            <th>Team Name</th>
            <th>Active Users</th>
          </tr>
        </thead>
        <tbody>
          {teams.size === 0 ? (
            <tr>
              <td colSpan="4" className="no-teams">
                No teams for this department
              </td>
            </tr>
          ) : (
            teams.map(team => (
              <TeamTableRow
                team={team}
                key={team.id}
                showTeamDialog={showTeamDialog}
                onStageTeamForMove={this.props.onStageTeamForMove}
                onDiscardTeamMove={this.props.onDiscardTeamMove}
                onStageDepartmentToReceive={this.props.onStageDepartmentToReceive}
                departments={this.props.departments}
                onDeleteTeam={this.props.onDeleteTeam}
                TeamMoveDialogActions={this.props.TeamMoveDialogActions}
              />
            ))
          )}
        </tbody>
      </table>
    );
  }
}
